module.exports = __webpack_public_path__ + "img/13_5.7226dbed.png";